import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import {
  startFullScreenLoadingAction,
  stopFullScreenLoadingAction,
} from "../../../data/redux/action/fullScreenLoadingAction";
import { profileDetailsService } from "../../../utility/services/profileDetailsService";
import CustomModal from "../../components/customModal/CustomModal";
import TopHeaderComponent from "../../components/TopHeaderComponent";
import { WHITE_COLOR } from "../../resources/colorsManager";
import { SUCCESS } from "../../resources/constantsManager";
import ConfirmationModalBody from "./ConfirmationModalBody";
import { VirtualAccount } from "./DeveloperComponent";
import GenerateKeyModal from "./GenerateKeyModal";
import ProductionModalBody from "./ProductionModalBody";
import WebhookComponent from "./WebhookComponent";
import WebhookModal from "./WebhookModal";

const Developers = ({ profileDetails }) => {
  const [openTestModal, setOpenTestModal] = useState(false);
  const [generateKeyModal, setGenerateKeyModal] = useState(false);
  const [webhookModal, setWebhookModal] = useState(false);
  const [updateUrl1, setUpdateUrl1] = useState("");
  const [updateUrl2, setUpdateUrl2] = useState("");
  const [currentStatusChange, setCurrentStatusChange] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const onClickSendOtp = (email) => {
    dispatch(startFullScreenLoadingAction());
    setLoading(true);
    ApiRequestPost.sendOtpForForgotPassword(email)
      .then((data) => {
        if (data.status === SUCCESS) {
          enqueueSnackbar(data.message, {
            variant: "success",
          });
          setOpenConfirmationModal(false);
          setWebhookModal(true);
        } else {
          enqueueSnackbar(data.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
        dispatch(stopFullScreenLoadingAction());
      });
  };

  useEffect(() => {
    dispatch(profileDetailsService());
  }, []);
  return (
    <div>
      <TopHeaderComponent
        headerName="Developer"
        showDownload={false}
        showFilter={false}
      />
      <div
        style={{
          backgroundColor: WHITE_COLOR,
          borderRadius: "20px",
          color: "black",
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "space-between",
          padding: "20px 25px",
          flexDirection: "column",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <VirtualAccount title="Virtual Account Number" />
          </div>

          <div>
            <p
              style={{
                fontSize: "14px",
                color: "black",
                margin: "0px",
                marginLeft: "30px",
              }}
            >
              {profileDetails?.accountNumber} | {profileDetails?.ifscCode} |{" "}
              {profileDetails?.businessName}
            </p>
          </div>
        </div>
      </div>

      <WebhookComponent
        onButtonClicked={() => setWebhookModal(true)}
        url1={profileDetails?.validateUrl}
        url2={profileDetails?.notifyUrl}
        date={profileDetails?.lastModifiedDate}
        onClickNotify={() => {
          // setWebhookModal(true);
          setUpdateUrl2(profileDetails?.validateUrl);
          setUpdateUrl1(profileDetails?.notifyUrl);
          setCurrentStatusChange(1);
          setOpenConfirmationModal(true);
        }}
        onClickValidate={() => {
          // setWebhookModal(true);
          setUpdateUrl1(profileDetails?.notifyUrl);
          setUpdateUrl2(profileDetails?.validateUrl);
          setCurrentStatusChange(0);
          setOpenConfirmationModal(true);
        }}

        // onClickNotify={(val) => {
        //   setUpdateUrl1(val);
        //   setUpdateUrl2(profileDetails?.notifyUrl);
        // }}
        // onClickValidate={(val) => {
        //   setUpdateUrl1(profileDetails?.validateUrl);
        //   setUpdateUrl2(val);
        // }}
      />
      {openConfirmationModal && (
        <CustomModal
          open={openConfirmationModal}
          onClose={() => setOpenConfirmationModal(false)}
        >
          <ConfirmationModalBody
            onClickNo={() => {
              setOpenConfirmationModal(false);
            }}
            onClickYes={() => {
              onClickSendOtp(profileDetails?.emailId);
            }}
            loading={loading}
          />
        </CustomModal>
      )}
      {openTestModal && (
        <CustomModal
          open={openTestModal}
          onClose={() => setOpenTestModal(false)}
        >
          <ProductionModalBody
            closeModal={() => setOpenTestModal(false)}
            onSuccess={() => {
              // setProductionMode(true);
            }}
          />
        </CustomModal>
      )}

      {generateKeyModal && (
        <CustomModal
          open={generateKeyModal}
          onClose={() => setGenerateKeyModal(false)}
        >
          <GenerateKeyModal closeModal={() => setGenerateKeyModal(false)} />
        </CustomModal>
      )}
      {webhookModal && (
        <CustomModal open={webhookModal} onClose={() => setWebhookModal(false)}>
          <WebhookModal
            closeModal={() => setWebhookModal(false)}
            notifyUrl={updateUrl1}
            validateUrl={updateUrl2}
            currentStatus={currentStatusChange}
            onSuccess={() => {
              setWebhookModal(false);
              dispatch(profileDetailsService());
            }}
            email={profileDetails?.emailId}
          />
        </CustomModal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profileDetails: state.profileDetailsReducer.details,
  };
};
export default connect(mapStateToProps)(Developers);
